export default "__VITE_ASSET__BLcIj5hr__"